import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import { MotionPathHelper } from "gsap/MotionPathHelper";
import { SlowMo } from "gsap/EasePack";

gsap.registerPlugin(MotionPathPlugin, ScrollTrigger, SplitText, DrawSVGPlugin, MotionPathHelper, SlowMo, MotionPathHelper);

export default {
    mounted() {
        this.$nextTick(

        );
    },
    destroyed() {

    },
    methods: {
        strategyContents: function() {
            let timeLine = gsap.timeline({
                scrollTrigger: {
                    trigger: ".slide-section",
                    start: "top top",
                    end: "+=" + (window.innerHeight * 9.2),
                    scrub: 1,
                    pin: ".slide-section",
                    pinSpacing: false,
                }
            });
            timeLine.to(".slide-section", { y: -150, ease: "power4.out", duration: 10 });
            timeLine.to(".scroll_section_content", { opacity: 1, ease: "power4.out", duration: 10 });
        },
        counterAnimation() {
            var counter = gsap.utils.toArray(".counter");
            counter.forEach(count => {
                var target = { val: 0 },
                    number = count.dataset.number,
                    split = (number + "").split("."),
                    decimals = split.length > 1 ? split[1].length : 0;

                gsap.to(target, {
                    duration: 2,
                    val: number,
                    ease: "none",
                    roundProps: "innerText",
                    onUpdate: function() {
                        const val = gsap.getProperty(count, "innerText");
                        count.innerText = target.val.toFixed(decimals);
                    },
                    scrollTrigger: {
                        trigger: count,
                        start: "top bottom",
                        scrub: false,
                        markers: false
                    }
                });
            });
        },
        titleAnimation() {
            gsap.fromTo(".section-title h1", { autoAlpha: 0, opacity: 0, y: "80%" }, {autoAlpha: 1, opacity: 1, y: 0, ease:Power1.easeIn, duration: 0.8});

            // let split = new SplitText(".section-title h1 ", { type: "chars" });
            // let tl = gsap.timeline({ repeat: !1, yoyo: true, duration: 0.6 });
            // tl.fromTo(split.chars, { y: 200, rotation: 70, autoAlpha: 0 }, { rotation: 0, autoAlpha: 1, y: 0, ease: "back(4)", duration: 1, stagger: { from: "start", each: 0.05 } }, "+=.7")
        },
        contentAnimation: function() {
            let titles = document.querySelectorAll(".section-title");
            let content = document.querySelectorAll(".content-wrapper p");

            let reveal = document.querySelectorAll(".image-reveal");
            reveal.forEach((image) => {
                let timeLine = gsap.timeline({
                    scrollTrigger: {
                        trigger: image,
                        toggleActions: "restart none none reset"
                    }
                });
                var type = "";
                type = image.getAttribute("data-type");
                var img = image.getElementsByTagName("img");
                var layer = image.getElementsByClassName("revealer");
                timeLine.set(image, { autoAlpha: 1 });
                switch (type) {
                    case "left":
                        timeLine
                            .fromTo(layer, { skewX: "30", scale: 1.5, xPercent: 100 }, { skewX: "0", xPercent: -100, duration: 1.5, ease: "Power4.Out" })
                    case "bottom":
                        timeLine
                            .to(layer, { yPercent: 100, ease: "Power2.out", duration: 1, transformOrigin: "0% -100%" })
                    case "top":
                        timeLine
                            .to(layer, { yPercent: -100, xPercent: 0, duration: 0.9, transformOrigin: "0% 100%" })
                    case "slice":
                        var slices = image.getElementsByClassName("uncover_slice");
                        timeLine.to(slices, 1, {
                            height: 0,
                            ease: 'power4.InOut',
                            stagger: { amount: 0.2 }
                        }, 'start');

                    default:
                        timeLine
                            .fromTo(layer, { skewX: "30", scale: 2 }, { skewX: "0", xPercent: "100", duration: 0.8, transformOrigin: "0% 100%", ease: "Power4.Out" })
                        break;
                }
                timeLine.from(img, { scale: 1.2, duration: 0.8, ease: "Power2.out" }, "-=0.6");
            });
            titles.forEach((title) => {
                let tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: title,
                        toggleActions: "restart restart pause reverse"
                    }
                });
                tl
                    .fromTo(title, { y: "100%", opacity: 0 }, { y: 0, opacity: 1, ease: "power4.Out", stagger: .2, duration: 1.3 });
            });
            content.forEach((paragraph) => {
                let tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: paragraph,
                        toggleActions: "restart restart pause reverse"
                    }
                });
                tl
                    .fromTo(paragraph, { y: "100%", opacity: 0 }, { y: 0, opacity: 1, ease: "power4.Out", duration: .8 });
            });
        },
        imageAnimation: function() {
            let reveal = document.querySelectorAll(".image-reveal");
            reveal.forEach((image) => {
                let timeLine = gsap.timeline({
                    scrollTrigger: {
                        trigger: image,
                        toggleActions: "restart none none reset"
                    }
                });
                var type = "";
                type = image.getAttribute("data-type");
                var img = image.getElementsByTagName("img");
                var layer = image.getElementsByClassName("revealer");
                timeLine.set(image, { autoAlpha: 1 });
                switch (type) {
                    case "left":
                        timeLine
                            .fromTo(layer, { skewX: "30", scale: 1.5, xPercent: 100 }, { skewX: "0", xPercent: -100, duration: 1.5, ease: "Power4.Out" })
                    case "bottom":
                        timeLine
                            .to(layer, { yPercent: 100, ease: "Power2.out", duration: 1, transformOrigin: "0% -100%" })
                    case "top":
                        timeLine
                            .to(layer, { yPercent: -100, xPercent: 0, duration: 0.9, transformOrigin: "0% 100%" })
                    case "slice":
                        var slices = image.getElementsByClassName("uncover_slice");
                        timeLine.to(slices, 1, {
                            height: 0,
                            ease: 'power4.InOut',
                            stagger: { amount: 0.2 }
                        }, 'start');

                    default:
                        timeLine
                            .fromTo(layer, { skewX: "30", scale: 2 }, { skewX: "0", xPercent: "100", duration: 0.8, transformOrigin: "0% 100%", ease: "Power4.Out" })
                        break;
                }
                timeLine.from(img, { scale: 1.2, duration: 0.8, ease: "Power2.out" }, "-=0.6");
            });
        },
        worldOfZain_old: function() {
            var h = document.querySelector(".countries-wrapper").offsetHeight;
            var con = document.querySelector(".container").offsetWidth;
            var vbox = document.querySelector("#motionpath")
            vbox.setAttribute("viewBox", `0 1000 ${con} ${h}`);
            vbox.setAttribute("width", `${con}px`);
            vbox.setAttribute("height", `${h}px`);
            var countries = document.querySelectorAll(".country");
            countries.forEach(country => {
                var stats = country.querySelector(".col-left");
                var tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: country,
                        start: "10% 75%",
                        end: "+=" + (country.offsetHeight - 100),
                        scrub: true
                    },
                });
                tl.fromTo(stats, { autoAlpha: 0, y: "100%", opacity: 0 }, { autoAlpha: 1, y: 0, opacity: 1, duration: 1, ease: Power1.easeIn })
            });
            var countries = document.querySelectorAll(".country");
            countries.forEach(country => {
                var stats = country.querySelector(".col-left");
                var tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: country,
                        start: "10% 75%",
                        end: "+=" + (country.offsetHeight - 100),
                        scrub: true
                    },
                });
                tl.fromTo(stats, { autoAlpha: 0, y: "100%", opacity: 0 }, { autoAlpha: 1, y: 0, opacity: 1, duration: 1, ease: Power1.easeIn })
            });
        },
        worldOfZain: function() {
            var axis = [];
            var h = document.querySelector(".countries-wrapper").offsetHeight;
            var con = document.querySelector(".container").offsetWidth;
            var vbox = document.querySelector("#motionpath").setAttribute("viewBox", `136 383.31 ${con} ${h}`);
            window.addEventListener('resize', reload);
            function reload() {
                location.reload();
            };
            var countries = document.querySelectorAll(".country");
            countries.forEach(country => {
                var stats = country.querySelector(".col-left");
                var tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: country,
                        start: "10% 75%",
                        end: "+=" + (country.offsetHeight - 100),
                        scrub: true
                    },
                });
                tl.fromTo(stats, { autoAlpha: 0, y: "100%", opacity: 0 }, { autoAlpha: 1, y: 0, opacity: 1, duration: 1, ease: Power1.easeIn });
                var flag = country.querySelector(".countryFlag");
                axis.push(this.offset(flag));
            });

            var rawPath = MotionPathPlugin.arrayToRawPath(axis, { curviness: 0.3 });
            var d = MotionPathPlugin.rawPathToString(rawPath);
            let path = document.querySelector('#maskPath');
            let tl = gsap.timeline();
            tl
            .set('#maskPath',{drawSVG: "0%"})
            .set("#maskPath, #dashedPath", {attr: {d: d}});
            let timeLine = gsap.timeline({
                scrollTrigger: {
                    trigger: path,
                    start: "top 60%",
                    end: h,
                    scrub: true,
                }
            })
            timeLine
            .to(path,{drawSVG:"100%", ease: 'Power0.easeInOut'});
        },
        
        offset: function(el) {
            var adaptiveDivisor = 1.5;
            if (window.matchMedia("(max-width: 1400px)").matches) {
                adaptiveDivisor = 1.4;
            }
            if (window.matchMedia("(max-width: 767px)").matches) {
                adaptiveDivisor = 4;
            }
            var rect = el.getBoundingClientRect(),
            firstBlock = document.querySelector('.landing'),
            adaptiveMeaning = window.screen.width / 8,
            firstBlockHeight = firstBlock.offsetHeight,
            scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
            scrollTop = window.pageYOffset - firstBlockHeight / adaptiveDivisor || document.documentElement.scrollTop;
            console.log(scrollTop);
            if (window.matchMedia("(max-width: 1680px)").matches) {
                adaptiveMeaning = 80;
            }
            if (window.matchMedia("(max-width: 1440px)").matches) {
                adaptiveMeaning = -60;
            }
            if (window.matchMedia("(max-width: 767px)").matches) {
                adaptiveMeaning = 0;
            }
            return { x: rect.left - adaptiveMeaning, y: rect.top + (scrollTop) }
        },
        softBezier: function(target, values) {
    
            var points = [{
              x: gsap.getProperty(target, "x"),
              y: gsap.getProperty(target, "y"),
            }, ...values];
              
            var size = points.length;
            var mids = [];
            var p1, p2, i;
            
            for (i = 0; i < size - 1; i++) {
              
              p1 = points[i];
              p2 = points[i+1];
              
              mids.push({
                x: (p1.x + p2.x) / 2,
                y: (p1.y + p2.y) / 2
              });
            }
            
            var path = `M${points[0].x} ${points[0].y} Q`
            
            for (i = 1; i < size - 2; i++) {
              
              p1 = points[i];
              p2 = mids[i];
              
              path += ` ${p1.x} ${p1.y} ${p2.x} ${p2.y}`;
            }
            
            p1 = points[i];
            p2 = points[i+1];
            
            path += ` ${p1.x} ${p1.y} ${p2.x} ${p2.y}`;
            
            return path;
          }

    }
};